import { TFunction } from 'next-i18next';
import {
    CountryInterface,
    Option,
} from 'components/interfaces/GeneralInterface';
import { TNamespaceEnum } from 'types/types';
import { getTranslation } from 'utils/localization';

export const sortCountriesForFilter = (
    t: TFunction,
    countries: CountryInterface[]
): Option[] => [
    {
        value: 'CZ',
        label: getTranslation(t, TNamespaceEnum.countries, 'CZ'),
    },
    ...countries
        .filter((country) => country.code !== 'CZ')
        .map((country) => {
            return {
                label: getTranslation(
                    t,
                    TNamespaceEnum.countries,
                    country.code
                ),
                value: country.code,
            };
        })
        .sort((a, b) =>
            a.label.localeCompare(b.label, 'en', {
                numeric: true,
            })
        ),
];
